import React from "react";
import { connect } from "react-redux";
import { bindSuccess } from "Store/appStore/action";
import AccountActivation from "Components/AccountActivation";
/**
 * 友互通注册组件
 * @param {Boolean} needBind
 */
const AccountActivationEntry = ({ needBind, bindSuccess, updateAPPDataStore = '', is_cloud_register, deployType }) => {
    if (needBind) {
        return <AccountActivation
            bindSuccess={bindSuccess}
            updateAPPDataStore={updateAPPDataStore}
            is_cloud_register={is_cloud_register}
            deployType={deployType}
        />;
    }
    return null;
};

export default connect(
    state => ({
        is_cloud_register: state.appData.is_cloud_register,
        deployType: state.appData.deployType,
    }),
    { bindSuccess }
)(AccountActivationEntry);
